import { SavedCard } from '../WalletSavedCardsSection.types';

export const walletSavedCardsSectionMock: SavedCard[] = [
  {
    id: 'card-1',
    cardNumber: '8563',
    cardholderName: 'Samantha Smith',
    cardType: 'A',
    expiryDate: '12/26',
    isPrimary: true,
    cardStatus: 'ACTIVE',
    issuerProductCode: 'PREP',
  },
  {
    id: 'card-002',
    cardNumber: '9009',
    cardholderName: 'Samantha Smith',
    cardType: 'M',
    expiryDate: '08/27',
    isPrimary: false,
    cardStatus: 'ACTIVE',
  },
  {
    id: 'card-003',
    cardNumber: '2691',
    cardholderName: 'Samantha Smith',
    cardType: 'UNKNOWN',
    expiryDate: '03/25',
    isPrimary: false,
    cardStatus: 'ACTIVE',
  },
];

/**
 * Empty saved cards scenario for testing empty state
 */
export const walletSavedCardsEmptyMock: SavedCard[] = [];

/**
 * Single card scenario for testing singular badge label
 */
export const walletSavedCardsSingleMock: SavedCard[] = [
  {
    id: 'card-001',
    cardNumber: '4242',
    cardholderName: 'Jane Doe',
    cardType: 'V',
    expiryDate: '12/26',
    isPrimary: true,
    cardStatus: 'ACTIVE',
  },
];
